// Define Roles here as the Single Source of Truth
export const ROLES = {
    ClientsOptions: 'clients_options',
    ContractsOptions: 'contracts_options',
    UsersOptions: 'users_options',
    AnalysisOptions: 'analysis_options',
    WarrantiesOptions: 'warranties_options',
    SinisterOptions: 'sinister_options',
    SinisterValuesOptions: 'sinister_values_options',
    ReportsOptions: 'reports_options',
    FinancialOptions: 'financial_options',
    GeneralConditionsOptions: 'general_conditions_options',
    ChartsOptions: 'charts_options',
    PermissionsOptions: 'permissions_options',
    DashboardOptions: 'dashboard_options',
    MenuDashboard: 'menu_dashboard',
    ClientsDashboard: 'clients_dashboard',
    ContractsMenu: 'contracts_menu',
    UsersDashboard: 'users_dashboard',
    AnalysisDashboard: 'analysis_dashboard',
    WarrantiesMenu: 'warranties_menu',
    SinisterMenu: 'sinister_menu',
    ReportsMenu: 'reports_menu',
    FinancialMenu: 'financial_menu',
    GeneralConditionsMenu: 'general_conditions_menu',
    ChartsMenu: 'charts_menu',
    PermissionsMenu: 'permissions_menu',
    ComissionOptions: 'comission_options',
    ComissionMenu: 'comission_menu',
    PeopleOptions: 'people_options',
    PeopleMenu: 'people_menu',
    SignatureMenu: 'signature_menu',
    FireOptions: 'fire_options',
    FirePolicesOptions: 'fire_polices_options',
    FireFinancialOptions: 'fire_financial_options',
    FireMenu: 'fire_menu',
    BannerOptions: 'banner_options',
    BannerMenu: 'banner_menu',
    CapitalizationOptions: 'capitalization_options',
    CapitalizationMenu: 'capitalization_menu',
    IntegratorOptions: 'integrator_options',
    IntegratorMenu: 'integrator_menu',
    CreditRecoveryMenu: 'credit_recovery_menu',
    CreditRecoveryOptions: 'credit_recovery_options',
    AgreementsMenu: 'agreements_menu',
    AgreementsOptions: 'agreements_options',
    CollectionControlMenu: 'collection_control_menu',
    ToolsOptions: 'tools_options',
} as const;

export type PermissionRole = typeof ROLES[keyof typeof ROLES];

// Define Actions here as the Single Source of Truth
export const ACTIONS = {
    Add: 'add',
    Conclude: 'conclude',
    Filter: 'filter',
    Update: 'update',
    View: 'view',
    Cancel: 'cancel',
    Approve: 'approve',
    Reject: 'reject',
    Contest: 'contest',
    Serasa: 'serasa',
    LogSerasa: 'logSerasa',
    LogAnalysis: 'logAnalysis',
    CreditDetails: 'creditDetails',
    ViewBiometry: 'viewBiometry',
    ViewWarrantyBiometry: 'viewWarrantyBiometry',
    ViewSignedWarrantyContract: 'viewSignedWarrantyContract',
    SendPartnerCertificate: 'sendPartnerCertificate',
    ResendAnalysis: 'resendAnalysis',
    ClickSign: 'clickSign',
    Tipping: 'tipping',
    UpProposalPeriod: 'upProposalPeriod',
    UpProposalValues: 'upProposalValues',
    UpProposalAddress: 'upProposalAddress',
    UpProposalLocator: 'upProposalLocator',
    UpProposalCancel: 'upProposalCancel',
    UpProposalConcludeCancel: 'upProposalConcludeCancel',
    UpProposalPendencyCancel: 'upProposalPendencyCancel',
    UpProposalRemovePendencyCancel: 'upProposalRemovePendencyCancel',
    ReportFinancial: 'reportFinancial',
    ReportProposals: 'reportProposals',
    ReportAnalysis: 'reportAnalysis',
    ReportSinister: 'reportSinister',
    ReportAdmin: 'reportAdmin',
    ReportClient: 'reportClient',
    ReportLogAndAudit: 'reportLogAndAudit',
    BlockCancel: 'blockCancel',
    BlockMenuView: 'blockMenuView',
    BlockNotify: 'blockNotify',
    BlockClient: 'blockClient',
    WalletTransfer: 'walletTransfer',
    Contracts: "contracts",
    ContractsDetails: "contractsDetails",
    ContractsAdd: "contractsAdd",
    ContractsUpdate: "contractsUpdate",
    ContractsShoot: "contractsShoot",
    Biometria: "biometria",
    People: "people",
    Calculate: "calculate",
    Print: "print",
    Renew: "renew",
    Preview: "preview",
    Invoice: "invoice",
    Prolabore: "prolabore",
    Boleto: "boleto",
    AlterStatus: "alterStatus",
    UpdatePlans: "updatePlans",
    RevertAnalysis: "revertAnalysis",
    DisableSerasa: "disableSerasa",
    SetupFee: "setupFee",
    SolidaryTenant: "solidaryTenant",
    AttachFiles: "attachFiles",
    AdjustInstallments: "adjustInstallments",
    SetInstallmentsPaid: "setInstallmentsPaid",
    CancelInstallments: "cancelInstallments",
    ReactivateInstallments: "reactivateInstallments",
    LaunchFinancialValues: "launchFinancialValues",
    CommissionLaunchBatch: "commissionLaunchBatch",
    CommissionCancelBatch: "commissionCancelBatch",
    CommissionReactivateBatch: "commissionReactivateBatch",
    CommissionLaunchSingle: "commissionLaunchSingle",
    CommissionCancelSingle: "commissionCancelSingle",
    CommissionViewDetails: "commissionViewDetails",

    // Financeiro > Livve (grupo, mesmo padrão do grupo Comissões acima — ações próprias, granulares
    // por operação, pra não colidir com View/Update genéricos do grupo Geral)
    LivveView: "livveView",
    LivveClose: "livveClose",
    LivveUndo: "livveUndo",
    LivveSend: "livveSend",
    LivveConfirmPayment: "livveConfirmPayment",

    // Financeiro > Borderô (módulo isolado /bordero) — item 14/16 do GARV2-1463/1464, ações que
    // só o Financeiro pode acionar (refletem no Sinistro via suspendedBy/status, ver gap doc).
    BorderoSuspendFinanceiro: "borderoSuspendFinanceiro",
    BorderoSchedule: "borderoSchedule",

    // Financeiro > Reajustes
    ReadjustView: "readjustView",
    ReadjustAdd: "readjustAdd",
    ReadjustUpdate: "readjustUpdate",

    // Usuários
    ResetPassword: "resetPassword",

	// Clientes
	ActivatePartners: "activatePartners",
	ChangePartnerOrigin: "changePartnerOrigin",

    // Análises
    ConvertAnalysisToPj: "convertAnalysisToPj",

    // Sinistro > Valores
    ViewBordero: "viewBordero",
    GenerateBordero: "generateBordero",
    ConfirmCollectionValues: "confirmCollectionValues",
    // Ações granulares do menu de ações do Borderô (GARV2-1463/1464, item 6) — uma por operação.
    SuspendBordero: "suspendBordero",
    LiftSuspensionBordero: "liftSuspensionBordero",
    CancelBordero: "cancelBordero",
    EditBorderoBankData: "editBorderoBankData",

    // Integrador / Fila de Processamento - Cron
    CronRun: "cronRun",
    CronEnable: "cronEnable",
    CronDisable: "cronDisable",
    CronPause: "cronPause",
    CronReload: "cronReload",
    CronDelete: "cronDelete",
    CronGlobalActions: "cronGlobalActions",

    // Integrador / Fila de Processamento - Analysis Queue
    QueueRetrySerasa: "queueRetrySerasa",
    QueueStopSerasa: "queueStopSerasa",
    QueueReprocessSerasa: "queueReprocessSerasa",
    QueueRestart: "queueRestart",
    QueueStop: "queueStop",
    QueueDelete: "queueDelete",

    // Cobrança
    Negotiate: "negotiate",

    // Cobrança / Jurídico (por setor)
    NegotiateCollection: "negotiateCollection",
    UpdateCaseStatusCollection: "updateCaseStatusCollection",
    ChangeSectorCollection: "changeSectorCollection",
    ChangeStageCollection: "changeStageCollection",
    RegisterInteractionCollection: "registerInteractionCollection",
    ChangeResponsibleCollection: "changeResponsibleCollection",

    NegotiateLegal: "negotiateLegal",
    UpdateCaseStatusLegal: "updateCaseStatusLegal",
    ChangeSectorLegal: "changeSectorLegal",
    ChangeStageLegal: "changeStageLegal",
    RegisterInteractionLegal: "registerInteractionLegal",
    ChangeResponsibleLegal: "changeResponsibleLegal",

    LaunchFutureValueCollection: "launchFutureValueCollection",
    LaunchFutureValueLegal: "launchFutureValueLegal",

    // Acordos (por setor, mesmo padrão de Cobrança/Jurídico em CreditRecoveryOptions)
    RenegotiateAgreementCollection: "renegotiateAgreementCollection",
    RenegotiateAgreementLegal: "renegotiateAgreementLegal",
    AlterAgreementStatusCollection: "alterAgreementStatusCollection",
    AlterAgreementStatusLegal: "alterAgreementStatusLegal",
    ReissueInstallmentCollection: "reissueInstallmentCollection",
    ReissueInstallmentLegal: "reissueInstallmentLegal",
    ManualSettleInstallmentCollection: "manualSettleInstallmentCollection",
    ManualSettleInstallmentLegal: "manualSettleInstallmentLegal",
    CancelInstallmentCollection: "cancelInstallmentCollection",
    CancelInstallmentLegal: "cancelInstallmentLegal",
    RegisterAgencyTransferCollection: "registerAgencyTransferCollection",
    RegisterAgencyTransferLegal: "registerAgencyTransferLegal",
    DefineAgencyTransferPlanCollection: "defineAgencyTransferPlanCollection",
    DefineAgencyTransferPlanLegal: "defineAgencyTransferPlanLegal",
    // Não é por setor — conciliação Sicoob é global (intervalo de datas), não tem sector no payload.
    SyncAgreementBillets: "syncAgreementBillets",

    // Garantias > Renovação
    RenewKeepCurrentPlan: "renewKeepCurrentPlan",

    // Garantias > Status / Logs
    ViewWarrantyLogs: "viewWarrantyLogs",

    // Clientes > Logs
    ViewClientLogs: "viewClientLogs",

    // Ferramentas
    ResendCertificateBulk: "resendCertificateBulk",
} as const;

export type PermissionAction = typeof ACTIONS[keyof typeof ACTIONS];

export interface PermissionModuleConfig {
    key: PermissionRole;
    label: string;
    type: 'menu' | 'options';
    actions: { action: PermissionAction; label: string; group?: string }[];
}

export const PERMISSIONS_CONFIG: PermissionModuleConfig[] = [
    {
        key: ROLES.MenuDashboard,
        label: 'Dashboard',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ClientsDashboard,
        label: 'Clientes',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ContractsMenu,
        label: 'Contratos',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.UsersDashboard,
        label: 'Usuários',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.AnalysisDashboard,
        label: 'Análises',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.WarrantiesMenu,
        label: 'Garantias',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.SinisterMenu,
        label: 'Sinistro',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.FireMenu,
        label: 'Incêndio',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ReportsMenu,
        label: 'Relatórios',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.FinancialMenu,
        label: 'Financeiro',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ComissionMenu,
        label: 'Premiação zz',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.GeneralConditionsMenu,
        label: 'Documentos para Download',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ChartsMenu,
        label: 'Gráficos',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.PermissionsMenu,
        label: 'Permissões',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.PeopleMenu,
        label: 'BlackList',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.SignatureMenu,
        label: 'Assinatura Eletronica',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },


    // --- OPTIONS PERMISSIONS ---
    {
        key: ROLES.DashboardOptions,
        label: 'Dashboard',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.ClientsOptions,
        label: 'Clientes',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.WalletTransfer, label: 'Transferência de Carteira' },
			{ action: ACTIONS.ActivatePartners, label: 'Ativar/Desativar Parceiros' },
			{ action: ACTIONS.ChangePartnerOrigin, label: 'Alterar Parceiro/Origem' },
            { action: ACTIONS.ViewClientLogs, label: 'Ver Logs do Cliente' },
        ]
    },
    {
        key: ROLES.ContractsOptions,
        label: 'Contratos',
        type: 'options',
        actions: [
            { action: ACTIONS.Contracts, label: 'Visualizar/Listar Contratos' },
            { action: ACTIONS.ContractsDetails, label: 'Detalhes do Contrato' },
            { action: ACTIONS.ContractsAdd, label: 'Novo Contrato' },
            { action: ACTIONS.ContractsUpdate, label: 'Editar Contrato' },
            { action: ACTIONS.ContractsShoot, label: 'Disparar Contrato' },
        ]
    },
    {
        key: ROLES.UsersOptions,
        label: 'Usuários',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.ResetPassword, label: 'Reset Senha' }
        ]
    },
    {
        key: ROLES.AnalysisOptions,
        label: 'Análises',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar', group: 'Geral' },
            { action: ACTIONS.Add, label: 'Adicionar', group: 'Geral' },
            { action: ACTIONS.Update, label: 'Atualizar', group: 'Geral' },
            { action: ACTIONS.Filter, label: 'Filtrar', group: 'Geral' },

            { action: ACTIONS.Conclude, label: 'Concluir', group: 'Fluxo' },
            { action: ACTIONS.AlterStatus, label: 'Alterar Status', group: 'Fluxo' },
            { action: ACTIONS.RevertAnalysis, label: 'Reverter Análises', group: 'Fluxo' },

            { action: ACTIONS.Serasa, label: 'Consultar Serasa', group: 'Serasa' },
            { action: ACTIONS.DisableSerasa, label: 'Desativar envio Serasa', group: 'Serasa' },

            { action: ACTIONS.LogAnalysis, label: 'Log da Análise', group: 'Logs' },
            { action: ACTIONS.LogSerasa, label: 'Log Serasa', group: 'Logs' },
            { action: ACTIONS.CreditDetails, label: 'Detalhes do Crédito', group: 'Logs' },

            { action: ACTIONS.ViewBiometry, label: 'Ver Biometria', group: 'Biometria' },
            { action: ACTIONS.Biometria, label: 'Reenviar Biometria', group: 'Biometria' },

            { action: ACTIONS.ResendAnalysis, label: 'Reenviar Análise', group: 'Fluxo' },
            { action: ACTIONS.UpdatePlans, label: 'Atualizar Planos Análise', group: 'Fluxo' },
            { action: ACTIONS.SolidaryTenant, label: 'Locatário Solidário', group: 'Extras' },
            { action: ACTIONS.ConvertAnalysisToPj, label: 'Converter análise para PJ', group: 'Extras' },
            { action: ACTIONS.SetupFee, label: 'Cobrar Taxa de Setup', group: 'Extras' },
            { action: ACTIONS.Tipping, label: 'Tombamento', group: 'Extras' },
            { action: ACTIONS.ClickSign, label: 'Enviar clickSign', group: 'Extras' }
        ]
    },
    {
        key: ROLES.WarrantiesOptions,
        label: 'Garantias',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar', group: 'Geral' },
            { action: ACTIONS.Add, label: 'Adicionar', group: 'Geral' },
            { action: ACTIONS.Update, label: 'Atualizar', group: 'Geral' },
            { action: ACTIONS.Filter, label: 'Filtrar', group: 'Geral' },

            { action: ACTIONS.UpProposalPeriod, label: 'Alterar Vigência', group: 'Edição da Garantia' },
            { action: ACTIONS.UpProposalValues, label: 'Alterar Valores', group: 'Edição da Garantia' },
            { action: ACTIONS.UpProposalAddress, label: 'Alterar Endereço', group: 'Edição da Garantia' },
            { action: ACTIONS.UpProposalLocator, label: 'Alterar Locador', group: 'Edição da Garantia' },
            { action: ACTIONS.AlterStatus, label: 'Alterar Status', group: 'Edição da Garantia' },
            { action: ACTIONS.ChangePartnerOrigin, label: 'Alterar Parceiro/Origem', group: 'Edição da Garantia' },

            { action: ACTIONS.Cancel, label: 'Cancelar', group: 'Cancelamento' },
            { action: ACTIONS.UpProposalCancel, label: 'Alterar Cancelamento', group: 'Cancelamento' },
            { action: ACTIONS.UpProposalPendencyCancel, label: 'Pendenciar Cancelamento', group: 'Cancelamento' },
            { action: ACTIONS.UpProposalRemovePendencyCancel, label: 'Remover Pendência', group: 'Cancelamento' },
            { action: ACTIONS.UpProposalConcludeCancel, label: 'Concluir Cancelamento', group: 'Cancelamento' },

            { action: ACTIONS.ViewSignedWarrantyContract, label: 'Visualizar Contrato Assinado', group: 'Contrato' },
            { action: ACTIONS.ViewWarrantyBiometry, label: 'Ver Biometria', group: 'Contrato' },
            { action: ACTIONS.SendPartnerCertificate, label: 'Enviar Certificado Parceiro', group: 'Contrato' },
            { action: ACTIONS.ViewWarrantyLogs, label: 'Ver Logs da Garantia', group: 'Logs' },

            { action: ACTIONS.RenewKeepCurrentPlan, label: 'Manter Plano Atual na Renovação', group: 'Renovação' }
        ]
    },
    {
        key: ROLES.ToolsOptions,
        label: 'Ferramentas',
        type: 'options',
        actions: [
            { action: ACTIONS.ResendCertificateBulk, label: 'Reenvio de Certificado', group: 'Certificado' },
        ]
    },
    {
        key: ROLES.SinisterOptions,
        label: 'Sinistro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.AlterStatus, label: 'Alterar Status' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' }
        ]
    },
    {
        key: ROLES.SinisterValuesOptions,
        label: 'Valores de Sinistro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' },
            { action: ACTIONS.Approve, label: 'Aprovar' },
            { action: ACTIONS.Reject, label: 'Rejeitar' },
            { action: ACTIONS.Contest, label: 'Contestar' },
            { action: ACTIONS.ViewBordero, label: 'Visualizar Borderôs', group: 'Borderô' },
            { action: ACTIONS.GenerateBordero, label: 'Gerar Borderô', group: 'Borderô' },
            { action: ACTIONS.SuspendBordero, label: 'Suspender Borderô', group: 'Borderô' },
            { action: ACTIONS.LiftSuspensionBordero, label: 'Retirar Suspensão do Borderô', group: 'Borderô' },
            { action: ACTIONS.CancelBordero, label: 'Cancelar Borderô', group: 'Borderô' },
            { action: ACTIONS.EditBorderoBankData, label: 'Editar Dados Bancários do Borderô', group: 'Borderô' },
            { action: ACTIONS.ConfirmCollectionValues, label: 'Confirmar Valores da Cobrança' }
        ]
    },
    {
        key: ROLES.ReportsOptions,
        label: 'Relatórios',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.ReportClient, label: 'Imobiliárias' },
            { action: ACTIONS.ReportAnalysis, label: 'Análises' },
            { action: ACTIONS.ReportProposals, label: 'Garantias' },
            { action: ACTIONS.ReportSinister, label: 'Sinistros' },
            { action: ACTIONS.ReportFinancial, label: 'Financeiros' },
            { action: ACTIONS.ReportAdmin, label: 'Administrativos' },
            { action: ACTIONS.ReportLogAndAudit, label: 'Auditoria e Logs' }
        ]
    },
    {
        key: ROLES.FinancialOptions,
        label: 'Financeiro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar', group: 'Geral' },
            { action: ACTIONS.Add, label: 'Adicionar', group: 'Geral' },
            { action: ACTIONS.Update, label: 'Atualizar', group: 'Geral' },
            { action: ACTIONS.Filter, label: 'Filtrar', group: 'Geral' },

            { action: ACTIONS.CancelInstallments, label: 'Cancelar parcelas', group: 'Operações' },
            { action: ACTIONS.ReactivateInstallments, label: 'Reativar parcelas', group: 'Operações' },
            { action: ACTIONS.AdjustInstallments, label: 'Ajustar parcelas', group: 'Operações' },
            { action: ACTIONS.SetInstallmentsPaid, label: 'Baixar parcelas', group: 'Operações' },
            { action: ACTIONS.LaunchFinancialValues, label: 'Lançar valores', group: 'Operações' },

            { action: ACTIONS.BlockMenuView, label: 'Entrar no menu de bloqueios', group: 'Bloqueios' },
            { action: ACTIONS.BlockNotify, label: 'Notificar cliente', group: 'Bloqueios' },
            { action: ACTIONS.BlockClient, label: 'Bloquear imobiliária', group: 'Bloqueios' },

            { action: ACTIONS.CommissionLaunchBatch, label: 'Comissões - Lançar em lote', group: 'Comissões' },
            { action: ACTIONS.CommissionCancelBatch, label: 'Comissões - Cancelar em lote', group: 'Comissões' },
            { action: ACTIONS.CommissionReactivateBatch, label: 'Comissões - Reativar em lote', group: 'Comissões' },
            { action: ACTIONS.CommissionLaunchSingle, label: 'Comissões - Lançar individual', group: 'Comissões' },
            { action: ACTIONS.CommissionCancelSingle, label: 'Comissões - Cancelar individual', group: 'Comissões' },
            { action: ACTIONS.CommissionViewDetails, label: 'Comissões - Ver detalhes', group: 'Comissões' },

            // Ações da aba Livve (dentro de Repasses), uma por operação — pedido do backend
            // formalizado em GAPS_LIVVE_V2_PARA_BACKEND.md.
            { action: ACTIONS.LivveView, label: 'Livve - Visualizar', group: 'Livve' },
            { action: ACTIONS.LivveClose, label: 'Livve - Fechar ciclo', group: 'Livve' },
            { action: ACTIONS.LivveUndo, label: 'Livve - Desfazer fechamento', group: 'Livve' },
            { action: ACTIONS.LivveSend, label: 'Livve - Enviar', group: 'Livve' },
            { action: ACTIONS.LivveConfirmPayment, label: 'Livve - Confirmar pagamento', group: 'Livve' },

            { action: ACTIONS.BorderoSuspendFinanceiro, label: 'Borderô - Suspender', group: 'Borderô' },
            { action: ACTIONS.BorderoSchedule, label: 'Borderô - Agendar', group: 'Borderô' },

            { action: ACTIONS.ReadjustView, label: 'Ver reajuste', group: 'Reajustes' },
            { action: ACTIONS.ReadjustAdd, label: 'Incluir reajuste', group: 'Reajustes' },
            { action: ACTIONS.ReadjustUpdate, label: 'Alterar reajuste', group: 'Reajustes' }
        ]
    },
    {
        // Permissão própria (não é um sub-item de FinancialOptions) — o rótulo "Financeiro - X" só
        // agrupa visualmente na lista de abas, mesmo padrão já usado em "Incêndio - Cotações" /
        // "Incêndio - Apólices" / "Incêndio - Financeiro" logo abaixo.
        key: ROLES.ComissionOptions,
        label: 'Financeiro - Comissão',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' }
        ]
    },
    {
        key: ROLES.GeneralConditionsOptions,
        label: 'Condições Gerais',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.ChartsOptions,
        label: 'Gráficos',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.PermissionsOptions,
        label: 'Permissões',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.PeopleOptions,
        label: 'BlackList',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.FireOptions,
        label: 'Incêndio - Cotações',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Criar Cotação' },
            { action: ACTIONS.Calculate, label: 'Calcular' },
            { action: ACTIONS.Update, label: 'Editar' },
            { action: ACTIONS.Print, label: 'Imprimir' },
            { action: ACTIONS.Cancel, label: 'Cancelar' }
        ]
    },
    {
        key: ROLES.FirePolicesOptions,
        label: 'Incêndio - Apólices',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Print, label: 'Imprimir' },
            { action: ACTIONS.Cancel, label: 'Cancelar' },
            { action: ACTIONS.Renew, label: 'Renovar' }
        ]
    },
    {
        key: ROLES.FireFinancialOptions,
        label: 'Incêndio - Financeiro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Preview, label: 'Prévia' },
            { action: ACTIONS.Invoice, label: 'Fatura' },
            { action: ACTIONS.Prolabore, label: 'Prolabore' },
            { action: ACTIONS.Boleto, label: 'Boleto' }
        ]
    },
    {
        key: ROLES.BannerMenu,
        label: 'Gestão de Banners',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.BannerOptions,
        label: 'Gestão de Banners',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.CapitalizationMenu,
        label: 'Capitalização',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.CapitalizationOptions,
        label: 'Capitalização',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Editar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.AttachFiles, label: 'Anexos' }
        ]
    },
    {
        key: ROLES.IntegratorMenu,
        label: 'Fila de Processamento',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.IntegratorOptions,
        label: 'Fila de Processamento',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },

            { action: ACTIONS.CronRun, label: 'Executar / Reprocessar', group: 'Cron Dinâmico' },
            { action: ACTIONS.CronEnable, label: 'Habilitar', group: 'Cron Dinâmico' },
            { action: ACTIONS.CronDisable, label: 'Desabilitar / Cancelar', group: 'Cron Dinâmico' },
            { action: ACTIONS.CronPause, label: 'Pausar', group: 'Cron Dinâmico' },
            { action: ACTIONS.CronReload, label: 'Recarregar', group: 'Cron Dinâmico' },
            { action: ACTIONS.CronDelete, label: 'Remover', group: 'Cron Dinâmico' },
            { action: ACTIONS.CronGlobalActions, label: 'Ações globais (pausar/parar todos)', group: 'Cron Dinâmico' },

            { action: ACTIONS.QueueRetrySerasa, label: 'Retry Serasa', group: 'Fila de Análise' },
            { action: ACTIONS.QueueStopSerasa, label: 'Parar Retry Serasa', group: 'Fila de Análise' },
            { action: ACTIONS.QueueReprocessSerasa, label: 'Reprocessar todos (Serasa)', group: 'Fila de Análise' },
            { action: ACTIONS.QueueRestart, label: 'Reiniciar item', group: 'Fila de Análise' },
            { action: ACTIONS.QueueStop, label: 'Parar item', group: 'Fila de Análise' },
            { action: ACTIONS.QueueDelete, label: 'Remover item', group: 'Fila de Análise' },
        ]
    },
    {
        key: ROLES.CreditRecoveryMenu,
        label: 'Cobrança',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.CreditRecoveryOptions,
        label: 'Cobrança',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },

            { action: ACTIONS.NegotiateCollection, label: 'Negociar', group: 'Cobrança' },
            { action: ACTIONS.UpdateCaseStatusCollection, label: 'Atualizar Status', group: 'Cobrança' },
            { action: ACTIONS.ChangeSectorCollection, label: 'Mudar de Setor', group: 'Cobrança' },
            { action: ACTIONS.ChangeStageCollection, label: 'Alterar Etapa', group: 'Cobrança' },
            { action: ACTIONS.RegisterInteractionCollection, label: 'Registrar Ação', group: 'Cobrança' },
            { action: ACTIONS.ChangeResponsibleCollection, label: 'Alterar Responsável', group: 'Cobrança' },
            { action: ACTIONS.LaunchFutureValueCollection, label: 'Lançar Valor Futuro', group: 'Cobrança' },

            { action: ACTIONS.NegotiateLegal, label: 'Negociar', group: 'Jurídico' },
            { action: ACTIONS.UpdateCaseStatusLegal, label: 'Atualizar Status', group: 'Jurídico' },
            { action: ACTIONS.ChangeSectorLegal, label: 'Mudar de Setor', group: 'Jurídico' },
            { action: ACTIONS.ChangeStageLegal, label: 'Alterar Etapa', group: 'Jurídico' },
            { action: ACTIONS.RegisterInteractionLegal, label: 'Registrar Ação', group: 'Jurídico' },
            { action: ACTIONS.ChangeResponsibleLegal, label: 'Alterar Responsável', group: 'Jurídico' },
            { action: ACTIONS.LaunchFutureValueLegal, label: 'Lançar Valor Futuro', group: 'Jurídico' },
        ]
    },
    {
        key: ROLES.AgreementsMenu,
        label: 'Acordos',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.AgreementsOptions,
        label: 'Acordos',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.SyncAgreementBillets, label: 'Sincronizar Boletos (Conciliação Sicoob)' },

            { action: ACTIONS.RenegotiateAgreementCollection, label: 'Renegociar', group: 'Cobrança' },
            { action: ACTIONS.AlterAgreementStatusCollection, label: 'Alterar Status do Acordo', group: 'Cobrança' },
            { action: ACTIONS.DefineAgencyTransferPlanCollection, label: 'Definir Repasse à Imobiliária', group: 'Cobrança' },
            { action: ACTIONS.ReissueInstallmentCollection, label: 'Gerar Nova Via de Parcela', group: 'Cobrança' },
            { action: ACTIONS.ManualSettleInstallmentCollection, label: 'Baixa Manual de Parcela', group: 'Cobrança' },
            { action: ACTIONS.CancelInstallmentCollection, label: 'Cancelar Parcela', group: 'Cobrança' },
            { action: ACTIONS.RegisterAgencyTransferCollection, label: 'Registrar Repasse à Imobiliária', group: 'Cobrança' },

            { action: ACTIONS.RenegotiateAgreementLegal, label: 'Renegociar', group: 'Jurídico' },
            { action: ACTIONS.AlterAgreementStatusLegal, label: 'Alterar Status do Acordo', group: 'Jurídico' },
            { action: ACTIONS.DefineAgencyTransferPlanLegal, label: 'Definir Repasse à Imobiliária', group: 'Jurídico' },
            { action: ACTIONS.ReissueInstallmentLegal, label: 'Gerar Nova Via de Parcela', group: 'Jurídico' },
            { action: ACTIONS.ManualSettleInstallmentLegal, label: 'Baixa Manual de Parcela', group: 'Jurídico' },
            { action: ACTIONS.CancelInstallmentLegal, label: 'Cancelar Parcela', group: 'Jurídico' },
            { action: ACTIONS.RegisterAgencyTransferLegal, label: 'Registrar Repasse à Imobiliária', group: 'Jurídico' },
        ]
    },
    {
        key: ROLES.CollectionControlMenu,
        label: 'Controle de Cobranças',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    }
];
